export const ADMIN_PHONE_E164 = '+17148667275';

export function isAdminPhone(phone: string | null | undefined): boolean {
  return (phone ?? '').trim() === ADMIN_PHONE_E164;
}
